'use strict';
var React = require('react');
var ReactRedux = require('react-redux');

//let client = require('../../../../sdk/client');
var ItemsHome = require('../../views/home/items');
var CategoriesHome = require('../../views/home/categories').CategoriesHomeComponent;
var BannersHome = require('../../views/home/banners');
var TitlePanelsHome = require('../../views/home/title-panels');
var CallToActionPanelsHome = require('../../views/home/call-to-action-panels');
var ValuePropositionPanelsHome = require('../../views/home/value-proposition-panels');
var BaseComponent = require('../shared/base');
var EnumCoreModule = require('../../public/js/enum-core');

var categoryActions = require('../../redux/categoryActions');

var OffersCarouselHomeComponent = require('../custom-views/offers-carousel.jsx');
//let OffersCarousel = require('./offers-carousel.jsx');

var BannersHomeComponent = require('../custom-views/home/banners.jsx');
var BannersBodyComponent = require('../../views/home/banners-body');


class HomepageWithPanelCompenent extends BaseComponent {
    componentDidMount() {
        let self = this;

        const urlParams = new URLSearchParams(window.location.search);
        const error = urlParams.get('error');

        if (typeof error != 'undefined') {
            if (error == 'invalid-token') {
                self.showMessage(EnumCoreModule.GetToastStr().Error.INVALID_TOKEN);
            }
            if (error == 'merchant-not-found') {
                self.showMessage({ 
                    type: "error",
                    body: "This page is no longer accessible.",
                    header: "Sorry!"
                });
            }
        }
        /*
        if(this.props.user) {
            console.log("Views/home/home-page-panels this.props.user");
            console.log(this.props.user);
            const script2 = document.createElement("script");
            script2.setAttribute("type", "text/javascript");

            script2.innerHTML = `_cio.identify({
                id: '${this.props.user.ID}', 
                email: '${this.props.user.Email}',
                created_at: 1339438758,
                first_name: '${this.props.user.FirstName}',
                last_name: '${this.props.user.LastName}',
                phone: '${this.props.user.PhoneNumber}',
                roles: '${this.props.user.Roles}',
                username: '${this.props.user.UserName}',
                cliente_consulta: '${this.props.user.CustomFields[0].Values[0]}',
                cart: 0
                });`;
            script2.async = true;

            document.body.appendChild(script2);
        }*/

        //var script = document.createElement('script');
        //script.src = "https://widget.surveymonkey.com/collect/website/js/tRaiETqnLgj758hTBazgdy4m7CGEZn2J_2BQglMsCpraR_2FCItP4k1YJOcwMxfoXnL4.js";
        //document.getElementById("smcx-sdk").appendChild(script);
    }

    getBannerPanel() {
        // console.log("getBannerPanel: ", this.props);
        // console.log("getBannerPanel: ", this.props.panels);
        if (this.props.panels != null) {
            const bannerPanel = this.props.panels.filter(p => p.Type.toLowerCase() === 'slider');
            if (bannerPanel && bannerPanel.length > 0) {
                return bannerPanel[0];
            }
        }
        return null;
    }

    renderDefault() {
        var self = this;
        var index = 10;
        var index2 = 11;        
        return (
            <React.Fragment>
                <div>
                    <div className='mundial-sections'
                        style={{
                            maxWidth: "700px",
                            margin: "0 auto 50px",
                            display: "block"
                    }}>
                        <video
                            style={{ 
                                width: "100%",
                                maxWidth: "700px"
                            }}
                            autoPlay
                            muted
                            loop
                        >
                            <source src="https://fe.bepensab2c.sandbox.arcadier.io/assets/images/bepensa/banners/2026/video-banner-mundial-cuadrado.mp4" type="video/mp4" />
                            {/* <source src="https://fe.bepensab2c.sandbox.arcadier.io/assets/images/bepensa/banners/2026/video-banner-mundial.mp4" type="video/mp4" /> */}
                            Your browser does not support the video tag.
                        </video>
                    </div>
                </div>
                <CategoriesHome key={index} categories={self.props.categories} numberOfCategories={self.props.numberOfCategories} loadMore={self.props.loadMore} collapsableCategories={self.props.collapsableCategories}  loadLess={self.props.loadLess}/>
                {/*<OffersCarouselHomeComponent offerts = {this.props} />*/}
                <ItemsHome key={index2} items={self.props.items} layoutItemCount={self.props.layoutItemCount} userPreferredLocationId={self.props.userPreferredLocationId} isBespoke={self.props.isBespoke} user={self.props.user} />    
                {/*<BannersBodyComponent banners =  {this.props} />*/}
            </React.Fragment>
        )
    }

    renderPanels() {
        var self = this;
        var panelViews = this.props.panels.map(function (panel, index) {
            if (panel.Type == 'Categories') {
                if (panel.IsVisible) {
                    var index2 = index + 1;
                    var index3 = index2 + 16;
                    return  (
                    <div key={index3}>
                        <div>
                            <div className='mundial-sections'
                                style={{
                                    maxWidth: "700px",
                                    margin: "0 auto 50px",
                                    display: "block"
                            }}>
                                <video
                                    style={{ 
                                        width: "100%",
                                        maxWidth: "700px"
                                    }}
                                    autoPlay
                                    muted
                                    loop
                                >
                                    <source src="https://fe.bepensab2c.sandbox.arcadier.io/assets/images/bepensa/banners/2026/video-banner-mundial-cuadrado.mp4" type="video/mp4" />
                                    {/* <source src="https://fe.bepensab2c.sandbox.arcadier.io/assets/images/bepensa/banners/2026/video-banner-mundial.mp4" type="video/mp4" /> */}
                                    Your browser does not support the video tag.
                                </video>
                            </div>
                        </div>
                        
                        <CategoriesHome categories={self.props.categories} numberOfCategories={self.props.numberOfCategories} loadMore={self.props.loadMore} collapsableCategories={self.props.collapsableCategories}  loadLess={self.props.loadLess} key={index} />
                        <OffersCarouselHomeComponent offerts = {self.props} key={index2}/>
                    </div>
                    );
                }
            } else if (panel.Type == 'LatestItems') {
                if (panel.IsVisible) {
                    var index2 = index + 1;
                    var index3 = index2 + 16;
                    return (<>
                    <div>
                        <div className='mundial-sections'
                            style={{
                                maxWidth: "1000px",
                                margin: "50px auto 0",
                                display: "block"
                        }}>
                            <a href='https://www.megamak.com.mx/search?categories=a82160ee-87cd-414b-b050-aa22e041a614'>
                                <img
                                    style={{ 
                                        width: "100%",
                                        maxWidth: "1000px"
                                    }}
                                    src="https://fe.bepensab2c.sandbox.arcadier.io/assets/images/bepensa/banners/2026/banner-b2c-mundial.png"
                                    alt="Patrocinador Oficial de la Selección Mexicana"
                                />
                            </a>
                        </div>
                    </div>
                    <div style={{paddingTop: '30px'}} key={index3}>
                        <ItemsHome items={self.props.items} key={index} layoutItemCount={self.props.layoutItemCount} userPreferredLocationId={self.props.userPreferredLocationId} isBespoke={self.props.isBespoke} user={self.props.user} />    
                        <ValuePropositionPanelsHome panel={panel} key={index2} />
                    </div>
                    </>)
                    
                }
            } else if (panel.Type == 'Title') {
                return (<TitlePanelsHome panel={panel} key={index} />)
            } else if (panel.Type == 'CalltoAction') {
                return (<CallToActionPanelsHome panel={panel} key={index} />)
            } else if (panel.Type == 'ValueProposition') {
                return (<BannersBodyComponent banners =  {self.props} key={index}/>)
            }
        });
        return panelViews;
    }


    render() {
        var index = 100;
        var index2 = 101;
        var index3 = 111;  
        var index4 = 113;  
        var index5 = 115;  
        var index6 = 116;  
        return (
            <div className="home-pg-container" key={index5}>
               {this.props.msjAzul != "" ? <div className="label-info-home" id="label-info-home-desktop" key={index6}>
                   <label suppressHydrationWarning={true}>
                   {this.props.msjAzul}
                   </label>  
                </div>
                :
                null
                }
                <BannersHomeComponent panel={this.getBannerPanel()} user={this.props.user} key={index}/>
                      
                                      <div className="" key={index4}>
                    <div className="container-fluid" key={index3}>
                        <div className="row" key={index2}>
                            {this.props.panels != null ? this.renderPanels() : this.renderDefault()}
                        </div>
                    </div>
                </div>    
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        user: state.userReducer.user,
        userPreferredLocationId: state.userReducer.userPreferredLocationId,
        categories: state.categoryReducer.categories,
        numberOfCategories: state.categoryReducer.numberOfCategories,
        panels: state.panelsReducer.panels,
        items: state.itemsReducer.items,
        layoutItemCount: state.settingsReducer.layoutItemCount,
        collapsableCategories: state.settingsReducer.collapsableCategories,
        isBespoke: state.settingsReducer.isBespoke,
        msjAzul:state.settingsReducer.msjAzul
    }
}

function mapDispatchToProps(dispatch) {
    return {
        loadMore: () => dispatch(categoryActions.loadMore()),
        loadLess: () => dispatch(categoryActions.loadLess())
    }
}

const HomepageWithPanelHome = ReactRedux.connect(
    mapStateToProps,
    mapDispatchToProps
)(HomepageWithPanelCompenent)

module.exports = {
    HomepageWithPanelHome,
    HomepageWithPanelCompenent
}